export const MAX_COMPARISON_COUNT = 4;
export const MIN_COMPARISON_COUNT = 2;

export const SPLITTER_SIZES = {
  DEFAULT: 300,
  MIN: 250,
  MAX: 500,
} as const;

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_CURRENT_PAGE = 1;
